import ApiService from './api.service';
export default class ResponsePortalService extends ApiService {
    constructor(ServiceUrl) {
        super(ServiceUrl);
    }
    GetAlertResponses = async (alertId, deviceId) => {
        try {
            const response = await this.get(`api/v2/alert-responses?AlertId=${alertId}&DeviceId=${deviceId}`);
            return response;
        }
        catch (error) {
            console.error(error);
            throw error;
        }
    };
    PostAlertResponses = async (data) => {
        try {
            const response = await this.post('api/v1/alert-responses', data);
            return response;
        }
        catch (error) {
            console.error(error);
            throw error;
        }
    };
}
